var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"iconArea",on:{"click":_vm.onClick}},[_c('div',{staticClass:"iconWrap"},[_c('icon-image',{attrs:{"iconUrl":_vm.iconUrl}})],1),(_vm.iconFrame)?_c('img',{staticClass:"iconFrame",attrs:{"src":_vm.iconFrame}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }